import { render, staticRenderFns } from "./EditTagsForm.vue?vue&type=template&id=49d09291&scoped=true&"
import script from "./EditTagsForm.vue?vue&type=script&lang=js&"
export * from "./EditTagsForm.vue?vue&type=script&lang=js&"
import style0 from "./EditTagsForm.vue?vue&type=style&index=0&id=49d09291&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d09291",
  null
  
)

export default component.exports